import {Component, Input, OnInit} from "@angular/core";
import {User, UserRole} from "../../../models/user";
import {ProtestInfo} from "../../../models/protest";
import {PartiesComponent} from "../parties.component";
import {StateService} from "../../../services/state.service";
import {dialogOptionalVars, UtilService} from "../../../services/util.service";
import {PartiesService} from "../../../services/parties.service";

@Component({
    selector: 'app-parties-info',
    templateUrl: './parties-info.component.html',
    styleUrls: ['./parties-info.component.scss'],
    standalone: false
})
export class PartiesInfoComponent implements OnInit {

  protected readonly UserRole = UserRole;

  initialized = false;
  isAssignPrimaryRepBtnDisplayed = false;
  isPrimaryProtesterAssigned = false;
  isPrimaryIntervenorAssigned = false;
  isPartiesListConsistOfPrimaryProtesterOrIntervenor = false;
  isGAOAdminAndPrimaryRepNotAssigned = false;
  isGAOAdminAndAllRepDeleted = false;
  canAddAgencyBtnBeDisplayed = false;
  canDeleteAgencyBtnBeDisplayed = false;
  canAgencyRepBeAdded = false;


  partiesList?: User[];
  @Input() set partyList(list: User[]) {
    this.partiesList = list;

    if (this.initialized) {
      this.setVars();
    }
  }


  @Input() protestInfo?: ProtestInfo;
  @Input() partyType = '';
  @Input() isOrphanIntervenor = 'N';
  @Input() parties!: PartiesComponent;
  @Input() savingDetails = { index: -1, saving: false };
  @Input() intervenorCompanyName = '';
  @Input() intervenorCompanyAddress = '';

  constructor(private util: UtilService,
              private partiesService: PartiesService,
              public stateService: StateService) {
  }

  ngOnInit() {
    console.debug(this.parties);
    this.setVars();
    this.initialized = true;
  }

  setVars() {
    if (this.parties) {
      this.canAgencyRepBeAdded = (this.partiesList && (this.partiesList.length > 0)) || false;
      this.isPrimaryProtesterAssigned = ( (this.partyType === 'P') && (this.partiesList && this.partiesList[0] && this.partiesList[0].role === 'PROTESTER') ) || false;
      this.isPrimaryIntervenorAssigned = ( (this.partyType === "I") && (this.partiesList && this.partiesList[0] && this.partiesList[0].role === 'INTERVENOR') ) || false;
      this.isPartiesListConsistOfPrimaryProtesterOrIntervenor = this.isPrimaryProtesterAssigned || this.isPrimaryIntervenorAssigned;
      this.isGAOAdminAndPrimaryRepNotAssigned = (this.stateService.userRole === UserRole.GAO_Admin) && !this.isPartiesListConsistOfPrimaryProtesterOrIntervenor;
      this.isGAOAdminAndAllRepDeleted = (this.stateService.userRole === UserRole.GAO_Admin) && (this.isOrphanIntervenor === 'Y');


      //is Primary Protester/Intervenor Btn can it be displayed?
      this.isAssignPrimaryRepBtnDisplayed = false;
      if (this.isGAOAdminAndPrimaryRepNotAssigned || this.isGAOAdminAndAllRepDeleted) {
        this.isAssignPrimaryRepBtnDisplayed = true;
      }

      //secondary agency
      this.canAddAgencyBtnBeDisplayed = false;
      this.canDeleteAgencyBtnBeDisplayed = false;
      if (this.partyType === 'SA') {
        if (this.canAgencyRepBeAdded && (this.parties.isGAOUserWithFullAccess || (this.parties.agencyUser && !this.parties.isFirmIdSame))) {
          this.canAddAgencyBtnBeDisplayed = true;
        }

        if (this.parties.isGAOUserWithFullAccess || (this.parties.isAgencyPOCUser && !this.parties.isFirmIdSame)) {
          this.canDeleteAgencyBtnBeDisplayed = true;
        }

        //primary agency
      } else if (this.partyType === 'A') {
        if (this.canAgencyRepBeAdded && (this.parties.isGAOUserWithFullAccess || (this.parties.agencyUser && this.parties.isFirmIdSame))) {
          this.canAddAgencyBtnBeDisplayed = true;
        }

        if (this.parties.isGAOUserWithFullAccess || (this.parties.isAgencyPOCUser && this.parties.isFirmIdSame)) {
          this.canDeleteAgencyBtnBeDisplayed = true;
        }
      }

    }
  }

  deletePartiesFromTheCase(typeOfRequest: string, user: User, index: number) {
    const areYourSureTitle = 'Delete ' + typeOfRequest;
    const areYouSureMessage = `Are you sure you want to remove <strong>${user.first_Name} ${user.last_Name}</strong> from this case?`;
    const areYouSureDialogParams: dialogOptionalVars = {
      cancelBtn: true,
      cancelText: 'No',
      confirmText: 'Yes'
    };

    this.util.displayDialogMessage(areYourSureTitle, areYouSureMessage, areYouSureDialogParams).subscribe((areYouSureResp) => {
      console.debug(areYouSureResp);
      const a_No = this.parties.a_No;

      if (areYouSureResp && a_No) {
        this.savingDetails.index = index;
        this.savingDetails.saving = true;

        this.partiesService.deleteSecondaryUser(user.user_Id, a_No).subscribe((deleteUserResp) => {
          console.debug(deleteUserResp);

          if (deleteUserResp.isSuccess) {
            const successMsg = `<strong>${user.first_Name} ${user.last_Name}</strong> has been successfuly removed.`

            this.parties.getListOfParties();
            this.util.displayDialogMessage('Success', successMsg).subscribe(() => {
            });
          } else {
            console.error(deleteUserResp);
            this.util.displayDialogMessage('Error', 'There was a problem removing the user from the case.');

            this.savingDetails.saving = false;
          }
        });
      }
    });
  }

  updateProtectiveOrder(user: User, index: number) {
    const a_No = this.parties.a_No;

    if (a_No) {
      const userPo = user.po.trim();
      const areYouSureMessage = userPo === 'Y' ?
        `Are you sure you want to remove <strong>${user.first_Name} ${user.last_Name}</strong> from the protective order?` :
        `Are you sure you want to add <strong>${user.first_Name} ${user.last_Name}</strong> to the protective order?`
      const areYouSureDialogParams: dialogOptionalVars = {
        cancelBtn: true,
        cancelText: 'No',
        confirmText: 'Yes'
      };
      this.util.displayDialogMessage('Update Protective Order', areYouSureMessage, areYouSureDialogParams).subscribe((areYouSureUpdatePO) => {
        if (areYouSureUpdatePO) {
          const updateStatus = userPo === 'Y' ? 'N' : 'Y';
          this.savingDetails.index = index;
          this.savingDetails.saving = true;

          this.partiesService.updateProtectiveOrder(user.user_Id, updateStatus, a_No).subscribe((protectiveResp) => {
            if (protectiveResp && !protectiveResp.error) {
              const updatePOSuccessMessage = userPo === 'Y' ?
                `<strong>${user.first_Name} ${user.last_Name}</strong> was removed from the protective order.` :
                `<strong>${user.first_Name} ${user.last_Name}</strong> was added to the protective order.`

              this.parties.getListOfParties();
              this.util.displayDialogMessage('Success', updatePOSuccessMessage).subscribe(() => {
                this.savingDetails.saving = false;
              });
            } else {
              this.util.displayDialogMessage('Error', 'There was a problem updating the protective order.');

              this.savingDetails.saving = false;
            }
          });
        }
      });
    }
  }

  onSecondaryRepAdd(typeOfRequest: string, invitorType: string, index: number): void {
    const agencyDialogTitle= 'Add Secondary Representative';
    const agencyDialogMessage = 'Enter Representative Email Address';

    const agencyDialogParams: dialogOptionalVars = {
      cancelBtn: true,
      getResponse: true,
      responseReq: true
    };
    this.util.displayDialogMessage(agencyDialogTitle, agencyDialogMessage, agencyDialogParams).subscribe((agencyDialogResp) => {
      console.debug(agencyDialogResp);

      if (agencyDialogResp) {
        const email = agencyDialogResp?.response;
        const a_No = this.parties.a_No;

        if (email && a_No) {
          this.savingDetails.index = index;
          this.savingDetails.saving = true;

          this.partiesService.invitePartiesToTheCase(email, invitorType, typeOfRequest, this.intervenorCompanyName, this.intervenorCompanyAddress, a_No).subscribe((inviteResp) => {
            console.debug(inviteResp);

            if (inviteResp) {
              const errorMsg = this.partiesService.validateInvitationRequests(inviteResp, typeOfRequest, invitorType, this.intervenorCompanyName, this.intervenorCompanyAddress, a_No);

              if (errorMsg) {
                this.util.displayDialogMessage('Error', errorMsg);

                this.savingDetails.saving = false;
              } else {
                const user = inviteResp.protest_Info;

                this.parties.getListOfParties();
                this.util.displayDialogMessage('Success', `Your invitation to <strong>${email}</strong> was successfully submitted.`).subscribe(() => {
                  this.savingDetails.saving = false;
                });
              }

            } else {
              this.savingDetails.saving = false;
            }
          });
        }
      }
    });
  }

  addPartiesToTheCase(typeOfRequest: string, invitorType: string, index: number): void {
    this.savingDetails.index = index;

    this.parties?.addPartiesToTheCase(typeOfRequest, invitorType, this.savingDetails);
  }

}
